<template>
  <div class="register-page">
    <div class="register-form glass-card">
      <h2>Register for your Basic Chatbot</h2>
      <!-- <p class="notice-p">Welcome to our new AI chatbot service! For our initial launch, we're excited to offer a 7 day money-back guarantee on our Basic Chatbot.</p> -->
      <p class="notice-p">Experience the innovative features of our Basic Chatbot, designed to assist your customers
        with their queries and enhance their
        digital interactions with your business. If the service doesn't meet your expectations, we'll provide a full
        refund within the first 7 days, no questions asked.</p>
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <input type="text" id="name" v-model="form.name" placeholder="Name" required class="input-field" />
        </div>

        <div class="form-group">
          <input type="text" id="surname" v-model="form.surname" placeholder="Surname" required class="input-field" />
        </div>

        <div class="form-group">
          <input type="email" id="email" v-model="form.email" placeholder="Email" required class="input-field" />
        </div>

        <div class="form-group">
          <input type="password" id="password" v-model="form.password" placeholder="Password" required class="input-field" />
        </div>

        <div class="form-group">
          <input type="password" id="confirmPassword" v-model="form.confirmPassword" placeholder="Confirm Password"
            required class="input-field" />
        </div>

        <div class="form-group">
          <input type="text" id="company" v-model="form.company" placeholder="Company" required class="input-field" />
        </div>

        <div class="form-group">
          <input type="url" id="website" v-model="form.website" placeholder="https://www.example.com"
            required class="input-field" />
        </div>

        <div class="form-group">
          <input type="tel" id="telephone" v-model="form.telephone" placeholder="Mobile Number" required class="input-field" />
        </div>

        <button type="submit" class="pill-button accent btn-wide" :disabled="isLoading">
          {{ isLoading ? "Registering..." : "Register" }}
        </button>
      </form>
      <div class="notice">
        <p>
          <strong>Note:</strong> You will be redirected to our secure payment gateway to complete your registration and
          process your monthly subscription of R999 / month.
        </p>
        <!-- <p>
          For the most secure experience, we do not keep any card details on our servers.
        </p> -->
      </div>

      <div v-if="successMessage" class="success-message" aria-live="polite">
        {{ successMessage }}
      </div>
      <div v-if="errorMessage" class="error-message" aria-live="assertive">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import { createPayfastSubscriptionPayment } from "../services/payfastPaymentService";

export default {
  name: "RegisterPage",
  data() {
    return {
      payfastUrl: process.env.VUE_APP_PAYFAST_URL,
      form: {
        name: "",
        surname: "",
        email: "",
        password: "",
        confirmPassword: "",
        company: "",
        website: "",
        telephone: "",
      },
      errorMessage: "",
      successMessage: "",
      isLoading: false,
      // item_name: "",
      // item_description: "",
      // item_amount: "",
      subscription_item_name: "Basic Chatbot",
      subscription_item_description: "Monthly Subscription for Basic Chatbot",
      recurring_amount: "999.00",
      first_billing_date: new Date().toISOString().split('T')[0],
      billing_frequency: "3",     // Monthly=3, Quarterly=6, Bi-annual=12, Annual=24
      number_of_cycles: "0",  // 0 for indefinite
    };
  },
  methods: {
    async handleSubmit() {
      this.errorMessage = "";
      this.successMessage = "";

      if (!/\S+@\S+\.\S+/.test(this.form.email)) {
        this.errorMessage = "Invalid email format!";
        return;
      }

      if (this.form.password.length < 8 || !/\d/.test(this.form.password)) {
        this.errorMessage =
          "Password must be at least 8 characters and include a number!";
        return;
      }

      if (this.form.password !== this.form.confirmPassword) {
        this.errorMessage = "Passwords do not match!";
        return;
      }

      if (!/^https?:\/\/[^\s]+$/.test(this.form.website)) {
        this.errorMessage = "Invalid website URL!";
        return;
      }

      // Store user data in localStorage
      localStorage.setItem('userData', JSON.stringify(this.form));

      this.isLoading = true;

      // try {
      //   // Send the registration data to the backend
      //   await axios.post(`${this.apiUrl}/users`, {
      //     name: this.form.name,
      //     email: this.form.email,
      //     password: this.form.password,
      //     company: this.form.company,
      //     company_website: this.form.website,
      //     telephone: this.form.telephone,
      //   });

      try {
        // Send the registration data to the microservice API
        const response = await createPayfastSubscriptionPayment(
          this.form.name,
          this.form.surname,
          this.form.email,
          this.form.telephone,
          this.subscription_item_name,
          this.subscription_item_description,
          this.recurring_amount,
          this.first_billing_date,
          this.billing_frequency,
          this.number_of_cycles
        );

        if (response.status < 200 || response.status >= 300) {
          throw new Error("Registration failed!");
        } else {
          // Create a form and submit it to PayFast
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = this.payfastUrl;

          // Add hidden input fields for the PayFast payload
          Object.keys(response).forEach(key => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = response[key];
            form.appendChild(input);
          });

          // Append the form to the document and submit it
          document.body.appendChild(form);
          form.submit();

          // this.successMessage = "Registration successful! Redirecting to login...";
          // this.errorMessage = "";
        }

        // setTimeout(() => {
        //   this.$router.push("/login");
        // }, 2000);
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message || "An unexpected error occurred.";
        this.successMessage = "";
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.register-page {
  height: 100vh;
  /* Full viewport height */
  display: flex;
  justify-content: center;
  /* Horizontally centers the form */
  align-items: center;
  /* Vertically centers the form */
  background-color: #0b0f1a;
  padding: 30px;
}

.register-form {
  border-radius: 18px;
  max-width: 600px;
  width: 100%;
  box-sizing: border-box;
}

h2 {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
  text-align: center;
}

form {
  padding: 20px;
  display: grid;
  gap: 12px;
}

.form-group {
  margin: 0;
}

.btn-wide {
  width: 100%;
  justify-content: center;
}

.error-message {
  color: #501204;
  margin-top: 0.75rem;
}

.success-message {
  color: var(--accent-orange);
  margin-top: 0.75rem;
}

.notice {
  margin: 20px;
  font-size: 0.85rem;
  background: var(--bg-glass);
  border-left: 4px solid var(--accent-orange);
  padding: 12px;
  color: var(--text-secondary);
  text-align: center;
  border-radius: var(--radius-xl);
}

.notice-p {
  padding-left: 15px;
  padding-right: 15px;
  font-size: small;
  text-align: center;
  color: var(--text-muted);
}
</style>
